import { keyframes } from '@emotion/react';
import palette from '@lib/core/src/theme/palette';
import { styled, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const fadeInOut = keyframes`
  0% {
    opacity: 1;
  }
  40% {
    opacity: 0.6;
  }
  80%, 100% {
    opacity: 1;
  }
`;
const ThinkingText = styled(Typography)({
  color: palette.grey[500],
  fontSize: '13px'
});

export const WaveSpan = styled('span')<{ delay: number }>(({ delay }) => ({
  display: 'inline-block',
  animation: `${fadeInOut} 1.4s infinite`,
  animationDelay: `${delay}s`
}));

export const ThinkingWave = ({ text }: { text: string }) => (
  <ThinkingText as="span">
    {text.split('').map((char, i) => (
      <WaveSpan key={i} delay={i * 0.08}>
        {char}
      </WaveSpan>
    ))}
  </ThinkingText>
);

const Thinking = () => (
  <motion.div
    key="thinking"
    initial={{ opacity: 0, height: 0 }}
    animate={{ opacity: 1, height: 'auto' }}
    exit={{ opacity: 0, height: 0 }}
    transition={{
      ease: 'easeInOut',
      exit: {
        opacity: { duration: 0.05 },
        height: { duration: 0.5 }
      }
    }}
  >
    <ThinkingWave text="Thinking..." />
  </motion.div>
);

export default Thinking;
